export default __webpack_public_path__ + "static/media/digital.8bd3c7ad.svg";